import { MouseEvent, useCallback, useState } from 'react'
import { PopoverState } from '../typing'

export function usePopoverState(): PopoverState {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const onOpen = useCallback(
    (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget),
    [],
  )

  const onClose = useCallback(() => setAnchorEl(null), [])

  const open = Boolean(anchorEl)

  return {
    anchorEl,
    open,
    onOpen,
    onClose,
  }
}
